import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { Town } from 'src/app/core/models/town';
import { TownService } from 'src/app/core/services/general/town.service';

@Component({
  selector: 'app-town-input',
  templateUrl: './town-input.component.html',
  styleUrls: ['./town-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: TownInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: TownInputComponent,
    },
  ],
})
export class TownInputComponent {
  @Input()
  title = "Select Town...";

  @Input()
  isDisabled = false;

  public value?: string;
  public localValue?: CustomSelectOption;

  public townsList: Array<CustomSelectOption> = [];

  constructor(
    private townService: TownService,
  ) {
    this.townService
      .all()
      .subscribe((res: Array<Town>) => {
        this.townsList = res.map((el) => {
          return {
            name: `${el.name}`,
            value: el.uuid,
          }
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.townsList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
